import { useQuery } from '@tanstack/react-query';
import { ApiEndpoints } from '../../../../constants/endpoints/apiEndpoints.ts';
import { getAxios } from '../../../../lib/axios';
import { CompanyProject } from '../types';

export function useCompanyProjectsQuery(
  cityName: string[] | undefined,
  cityIds: number[] | undefined,
  start: string | undefined,
  end: string | undefined,
  companyId: number | undefined
) {
  return useQuery({
    queryKey: [ApiEndpoints.company.projects(companyId, cityName, cityIds, start, end)],
    retry: false,
    queryFn: () => companyProjectQuery(ApiEndpoints.company.projects(companyId, cityName, cityIds, start, end)),
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    gcTime: 1,
    enabled:
      companyId != undefined &&
      start != undefined &&
      end != undefined &&
      (cityName != undefined || cityIds != undefined)
  });
}

async function companyProjectQuery(endpoint: string) {
  return (await getAxios().get<CompanyProject[]>(endpoint)).data;
}
